import { createFileRoute, redirect } from '@tanstack/react-router';
import type { Session } from '@hlt/contracts';
import { apiKey } from '@hlt/web-kit/api';
import { requireSession } from '@hlt/web-kit/shell';
import { MfaSetupPage } from '@/features/auth/mfa-setup-page';

export const Route = createFileRoute('/auth/setup-2fa')({
    validateSearch: (search: Record<string, unknown>): { next?: string } =>
        typeof search.next === 'string' ? { next: search.next } : {},
    beforeLoad: async ({ context, location }) => {
        await requireSession(context.queryClient, location.href, true);
        const session = context.queryClient.getQueryData<Session>(apiKey('getSession'));
        if (!session?.mfaEnrollmentRequired) throw redirect({ to: '/', replace: true });
    },
    component: function SetupRoute() {
        return <MfaSetupPage next={Route.useSearch().next} />;
    },
});
